
webpack.register(
    'components/svg-image/svg-image',
    function() {
        return require('components/svg-image/svg-image');
    },
    false
);
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
webpack.register(
    'components/clamp-text/clamp-text',
    function() {
        return require('components/clamp-text/clamp-text');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/svg-image/svg-image\"/>\r\n<can-import from=\"components/image-universal/image-universal\"/>\r\n<can-import from=\"components/clamp-text/clamp-text\"/>\r\n\r\n{{#and data show}}\r\n    <div class=\"c-pill {{#eq data.color 'white'}}is-light{{/eq}}\">\r\n        <div class=\"c-pill__image-holder\">\r\n            <image-universal {image}=\"data.image\" class-name=\"c-pill__image\" />\r\n        </div>\r\n        <div class=\"c-pill__content\">\r\n            <div class=\"c-pill__text\">\r\n                <clamp-text text=\"{{data.title}}\" lines=\"2\"/>   \r\n            </div>\r\n            {{#if data.cta}}\r\n                <a ($click)=\"onCtaClick\" class=\"c-pill__row s-link\">\r\n                    <span class=\"c-pill__button--text\">{{data.cta}}</span>  \r\n                    <div class=\"c-pill__button\">\r\n                        <svg-image class-name=\"c-pill__link-button\" image=\"sprites.svg#icon-arrow\"></svg-image>\r\n                    </div>\r\n                </a>\r\n            {{/if}}\r\n        </div>\r\n        <div class=\"c-pill__close-button\" ($click)=\"hidePill\">\r\n            <svg-image image=\"sprites.svg#icon-close\"></svg-image>\r\n        </div>\r\n    </div>\r\n{{/and}}\r\n");